// extracted by mini-css-extract-plugin
export default {"marginBottomGutterDouble":"marginBottomGutterDouble---Z178V","greyLabel":"greyLabel---MiMZj"};